import { FileList } from "./components/fileList";
import { FolderList } from "./components/folderList";

export const FileDisplay: React.FC = () => {
  return (
    <div className="border-grey2 mt-[22px] grid grid-cols-[228px_minmax(0,1fr)] items-stretch rounded-[10px] border bg-white">
      <FolderList />

      <FileList />
    </div>
  );
};
